import { useAuth } from '../lib/session'

/**
 * Shown when Google authenticated somebody who is not on the app_users
 * allowlist. Their session has already been terminated by the time this
 * renders — see lib/session.tsx.
 *
 * The message is deliberately plain. It does not say whether the address is
 * "known", does not offer a way to request access, and does not hint at what
 * the application contains.
 */
export default function Denied() {
  const { deniedEmail, signOut } = useAuth()

  return (
    <div className="gate">
      <div className="gate-card">
        <h1>No access</h1>
        <p className="gate-sub">
          {deniedEmail ? <strong>{deniedEmail}</strong> : 'That account'} is not
          set up to use Agent Care.
        </p>
        <button className="secondary-btn" onClick={() => void signOut()}>
          Try a different account
        </button>
        <p className="gate-fine">
          If you think this is wrong, ask Chris to add you.
        </p>
      </div>
    </div>
  )
}
